import { render, staticRenderFns } from "./ToolsDetails.vue?vue&type=template&id=5cd67fc9&scoped=true"
import script from "./ToolsDetails.vue?vue&type=script&lang=js"
export * from "./ToolsDetails.vue?vue&type=script&lang=js"
import style0 from "./ToolsDetails.vue?vue&type=style&index=0&id=5cd67fc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd67fc9",
  null
  
)

export default component.exports